export default "__VITE_ASSET__f6af363e__"